export default "__VITE_ASSET__DI0Qlr5B__"